import { Alert } from '@/components/shared/Alert';
import { Box } from '@mui/material';
import { ReactNode, useMemo } from 'react';

export interface AggregatedAlertsProps {
    alertList: AlertList[];
}

export interface AlertList {
    alertId: number;
    severity: 'error' | 'warning' | 'info' | 'success';
    message: string | ReactNode;
}

export const AggregatedAlerts = ({ alertList }: AggregatedAlertsProps) => {
    let severitySortedAlerts = useMemo(
        () =>
            alertList.sort((a, b) => {
                if (a.severity === 'error') return -1;
                if (b.severity === 'error') return 1;
                if (a.severity === 'warning') return -1;
                if (b.severity === 'warning') return 1;
                if (a.severity === 'info') return -1;
                if (b.severity === 'info') return 1;
                return 0;
            }),
        [alertList]
    );

    return (
        <Box sx={{ width: '100%' }}>
            {severitySortedAlerts.map((alert) => {
                return (
                    <Alert
                        key={alert.alertId}
                        severity={alert.severity}
                        message={alert.message}
                        sx={{ marginBottom: '16px' }}
                    />
                );
            })}
        </Box>
    );
};
